import PersonType from '@/classes/facturae/PersonType'
import ResidenceType from '@/classes/facturae/ResidenceType'
export default class Issuer {
  /** @type {string} */ Direccion = null
  /** @type {string} */ Poblacion = null
  /** @type {string} */ CodigoPostal = null
  /** @type {string} */ Provincia = null
  /** @type {string} */ CodigoPais = null
  /** @type {string} */ Telefono = null
  /** @type {string} */ RazonSocial = null
  /** @type {string} */ PersonaFisicaNombre = null
  /** @type {string} */ PersonaFisicaPrimerApellido = null
  /** @type {string} */ PersonaFisicaSegundoApellido = null
  /** @type {string} */ CIF = null
  /** @type {PersonType} */ PersonaFisica = PersonType.FISICA
  /** @type {ResidenceType} */ TipoResidencia = ResidenceType.RESIDENTE
}
